// extracted by mini-css-extract-plugin
export default {"list":"styles_list__-JzyE","checked":"styles_checked__URbPa"};